import React, { useState } from 'react';
import classNames from 'classnames';

import Button from 'src/components/ui/button';
import IconButton from 'src/components/ui/icon-button';
import { ReactComponent as Minus } from 'src/assets/icons/minus.svg';
import { ReactComponent as Plus } from 'src/assets/icons/plus.svg';

import { LOCALES } from 'src/constants';
import { formatMoney } from 'src/utils';
import type { CartLotProps } from './cart-lot.props';

import './cart-lot.scss';

const CartLot = ({
  count,
  maxCount,
  name,
  price,
  onDecrement,
  onIncrement,
  onRemove,
}: CartLotProps) => {
  const [isLastLotItem, setIsLastLotItem] = useState<boolean>(!count);
  const formattedPrice = formatMoney(price * count);

  const handleDecrementLot = () => {
    if (count === 1) {
      setIsLastLotItem(true);
    } else {
      onDecrement();
    }
  };

  return (
    <div className={classNames('cart-lot', isLastLotItem && 'cart-lot_empty')}>
      <div className="cart-lot__title">{name}</div>
      <div className="cart-lot__price">{formattedPrice}</div>
      {isLastLotItem && <div className="cart-lot__question">{LOCALES.REMOVE_FROM_CART}</div>}
      <div className="cart-lot__controls">
        {isLastLotItem ? (
          <>
            <Button
              className="cart-lot__button"
              label={LOCALES.YES}
              onClick={onRemove}
              size="mini"
              theme="outlined"
            />
            <Button
              className="cart-lot__button"
              label={LOCALES.NO}
              onClick={() => setIsLastLotItem(false)}
              size="mini"
              theme="outlined"
            />
          </>
        ) : (
          <>
            <IconButton
              ariaLabel="-1"
              icon={<Minus className="cart-lot__decrement" />}
              onClick={handleDecrementLot}
              size="mini"
              theme="outlined"
            />
            <span className="cart-lot__count">{count}</span>
            <IconButton
              ariaLabel="+1"
              icon={<Plus className="cart-lot__increment" />}
              isDisabled={count >= maxCount}
              onClick={onIncrement}
              size="mini"
              theme="outlined"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default CartLot;
